import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useFoldersUserQuery } from "../../graphql/folder.hooks";
import Pagination from "../../components/pagination";
import { useTranslation } from "react-i18next";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import { useDebounceEffect } from "../../hooks/useDebounceEffect";

export const AllFolders = () => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const {
    data: folders,
    loading: foldersLoading,
    refetch,
  } = useFoldersUserQuery();

  const projectSettings = JSON.parse(localStorage.getItem("mePageSettings"));
  const [currentPage, setCurrentPage] = useState(
    projectSettings?.projectPage?.currentPage || 1
  );
  const [searchTerm] = useState("");
  const [limit, setLimit] = useState(projectSettings?.projectPage?.limit || 12);

  const pagination = folders?.foldersUser?.paginator;
  const folderCount = pagination?.totalPages || 0;
  const totalItems = pagination?.totalItemCount || 0;
  const firstItemIndex = pagination
    ? (currentPage - 1) * pagination.itemNumberPerPage + 1
    : 0;
  const lastItemIndex = pagination
    ? Math.min(currentPage * pagination.itemNumberPerPage, totalItems)
    : 0;

  const handleSearch = () => {
    refetch({
      search: searchTerm,
      page: currentPage,
      limit,
    });
  };

  useDebounceEffect(handleSearch, 1000, [searchTerm]);

  const handleLimitChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLimit = Number(event.target.value);
    setLimit(newLimit);
    setCurrentPage(1);
    refetch({
      search: searchTerm,
      page: 1,
      limit: newLimit,
    });
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    document.title = "All Folders";
  }, []);

  if (foldersLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>All Folders</h1>
        </div>
      </div>
      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <table className="col-11 mb-5">
          <thead>
            <tr>
              <th>Id</th>
              <th>Title</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {folders?.foldersUser.folders.map(({ id, title, domain }: any) => (
              <tr key={id} style={{ lineHeight: "2.5", height: "50px" }}>
                <td style={{ width: "75px" }}>{id}</td>
                <td className="text-break">{title}</td>
                <td className="text-center" style={{ width: "100px" }}>
                  <Link
                    to={`${lng}/projects/${domain?.id}/folder/${id}`}
                    className="text-primary me-3 me-md-4"
                    style={{ textDecoration: "none" }}
                  >
                    show
                  </Link>
                  <Link
                    to={`${lng}/folder/${id}/edit`}
                    className="text-primary me-3 me-md-4"
                    style={{ textDecoration: "none" }}
                  >
                    edit
                  </Link>
                  <Link
                    to={`${lng}/user/access/folder/${id}/access`}
                    className="text-primary"
                    style={{ textDecoration: "none" }}
                  >
                    share
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="col-12 d-flex justify-content-between align-items-center bg-white px-3 px-md-5 py-3 mt-5 rounded">
          <Pagination
            t={t}
            pages={folderCount}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            firstItemIndex={firstItemIndex}
            lastItemIndex={lastItemIndex}
            totalItems={totalItems}
            limit={limit}
            onLimitChange={handleLimitChange}
          />
        </div>
      </div>
    </div>
  );
};
